const $$splitComponentImporter = () => import('/src/src/routes/_authenticated/_feature_announcement/communities/$communityId/manage.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
// Network Manage Layout
export const Route = createFileRoute("/_authenticated/_feature_announcement/communities/$communityId/manage")({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});